import React, { FC } from 'react'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { Image } from 'react-bootstrap'
import flyingEnvelopes from '../../../assets/img/flying_envelopes.svg'
import './styles.scss'

const LoginLayout: FC<RouteComponentProps> = props => {
  const { children } = props

  return (
    <div className="background_img_container">
      <Image src={flyingEnvelopes} alt="Flying_envelopes" className="flying-envelopes-img" />
      <div className="inner-component">{children}</div>
    </div>
  )
}

export default withRouter(LoginLayout)
